import { createFileRoute } from '@tanstack/react-router'
import { CREATE_ACCESS } from '../../../app/access'
import { requireAccess } from '../../../app/guards'
import { taxRatesQueryOptions } from '../../../features/finance/queries'
import { NewInvoicePage } from '../../../features/sales/invoice-pages'
import { salesSettingsQueryOptions } from '../../../features/sales/queries'
import { newInvoiceSearchSchema } from '../../../features/sales/search'

export const Route = createFileRoute('/_app/invoices/new')({
  staticData: { crumb: 'invoiceNew' },
  validateSearch: newInvoiceSearchSchema,
  beforeLoad: ({ context, search }) =>
    requireAccess(context.session, CREATE_ACCESS[search.kind === 'DEBIT_NOTE' ? 'debitNote' : 'invoice']),
  loader: async ({ context }) => {
    // The tax mode prices the lines; the rates give the first line its default tax.
    await Promise.all([
      context.queryClient.ensureQueryData(salesSettingsQueryOptions),
      context.queryClient.ensureQueryData(taxRatesQueryOptions),
    ])
  },
  component: NewInvoicePage,
})
